import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import TopBarEspace from "../components/TopBarEspace";
import { TiHome } from "react-icons/ti";
import { IoPerson } from "react-icons/io5";
import { BsCalendarEvent } from "react-icons/bs";
import { MdAddCircle } from "react-icons/md";
import RappelPaiements from '../components/RappelPaiements';
const EspaceClient = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const shortcuts = [
    { label: "Dashboard", icon: TiHome, path: "/EspaceClient" },
    { label: "Profil", icon: IoPerson, path: "/EspaceClient/profil" },
    { label: "Mes Événements", icon: BsCalendarEvent, path: "/EspaceClient/mesevents" },
    { label: "Ajouter Event", icon: MdAddCircle, path: "/EspaceClient/mesevents/ajouter" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="lg:grid lg:grid-cols-[220px_1fr] w-full h-screen bg-white">

      {/* Sidebar desktop */}
      <aside className="hidden lg:block border-r border-gray-200 bg-color4">
        <Sidebar />
      </aside>

      {/* Contenu principal */}
      <div className="flex flex-col h-screen overflow-hidden">

        {/* Barre du haut espace créateur — raccourci profil + notifications + titre de page */}
        <TopBarEspace />

        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>

        {/* Barre mobile */}
        <nav className="fixed bottom-0 left-0 w-full lg:hidden bg-color1 border-t border-gray-200 shadow-inner flex justify-around py-2.5 z-50">
          {shortcuts.map((item) => (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              title={item.label}
              className={`flex items-center justify-center p-2 rounded-full transition-all
                ${isActive(item.path)
                  ? "text-color3 font-semibold"
                  : "text-color2"
                }`}
            >
              <item.icon size={24} />
            </button>
          ))}
        </nav>
      </div>
      <RappelPaiements />
    </div>
  );
};

export default EspaceClient;